import Cookies from 'js-cookie'

// token
const TokenKey = 'Token'

export function getToken() {
  // return Cookies.get(TokenKey)
  // return localStorage.getItem('token')||'';
  return sessionStorage.getItem('token')||'';
}

export function getVirtualStatus() {
  // return localStorage.getItem('virtualStatus') == 1 ? 'NO' : 'YES';
  return sessionStorage.getItem('virtualStatus') == 1 ? 'NO' : 'YES';
}

export function setToken(token) {
  // return Cookies.set(TokenKey, token)
  return sessionStorage.setItem(TokenKey, token)
}


export function removeToken() {
  // return Cookies.remove(TokenKey)
  return sessionStorage.removeItem(TokenKey)
}

// userinfo
const userName = 'userName'

export function getUserName() {
    // return Cookies.get(userName)
    return sessionStorage.getItem(userName)
}

export function setUserName(user) {
    // return Cookies.set(userName, user)
    return sessionStorage.setItem(userName, user)
}

export function removeUserName() {
    // return Cookies.remove(userName)
    return sessionStorage.removeItem(userName)
}

// sessionStorage.removeItem
// sessionStorage.setItem
// sessionStorage.getItem
